import _ from 'underscore';
import {
  UAPImageType,
  UAPPlacementType as PT,
  UAPVideoType,
  // UAPPlacementMeta,
} from '../@types';

export const UAPLPlacementMetaList /* : Record<PT, UAPPlacementMeta> */ = {
  [PT.MMA_WideImage_4x1]: {
    placementType: PT.MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    // used to compare ratio values, use string instead of number to avoid precision issue
    aspectRatioStr: '4:1', // refer to: private\ad-creator-tools\packages\media-common-utils\src\aspect-ratio-config.js
    previewHeight: 152,
    minSize: [608, 152],
  },
  [PT.MMA_LandscapeImage_191x100]: {
    placementType: PT.MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
  },
  [PT.MMA_SquareImage_1x1]: {
    placementType: PT.MMA_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 400,
    minSize: [470, 470],
  },
  [PT.MMA_VerticalImage_1x2]: {
    placementType: PT.MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
  },

  // MMA in MSAN
  [PT.Audience_Network_WideImage_191x100]: {
    placementType: PT.Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },
  [PT.MSN_InArticle_Ad_150x100]: {
    placementType: PT.MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.MSN_Small_Headline_133x100]: {
    placementType: PT.MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.Audience_Network_SquareImage_1x1]: {
    placementType: PT.Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },

  // pmax
  [PT.PMax_MMA_LandscapeImage_191x100]: {
    placementType: PT.PMax_MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
  },
  [PT.PMax_MMA_WideImage_4x1]: {
    placementType: PT.PMax_MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    aspectRatioStr: '4:1',
    previewHeight: 152,
    minSize: [608, 152],
  },
  [PT.PMax_MMA_VerticalImage_1x2]: {
    placementType: PT.PMax_MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
  },
  [PT.PMax_Audience_Network_SquareImage_1x1]: {
    placementType: PT.PMax_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },
  [PT.PMax_Audience_Network_WideImage_191x100]: {
    placementType: PT.PMax_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.PMax_MSN_InArticle_Ad_150x100]: {
    placementType: PT.PMax_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.PMax_MSN_Small_Headline_133x100]: {
    placementType: PT.PMax_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.PMax_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.PMax_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },
  [PT.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100]: {
    placementType: PT.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 304,
    minSize: [612, 304],
  },
  [PT.PMax_MMAV2_MSN_Single_Carousel_169x100]: {
    placementType: PT.PMax_MMAV2_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
  },
  [PT.PMax_MMAV2_MSN_Restoday_124x100]: {
    placementType: PT.PMax_MMAV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
  },
  [PT.PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
  },
  [PT.PMax_MMAV2_MSN_River_191x100]: {
    placementType: PT.PMax_MMAV2_MSN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
  },

  //
  // MMA in MSAN V2
  [PT.MsanV2_Microsoft_Edge_Carouse_l201x100]: {
    placementType: PT.MsanV2_Microsoft_Edge_Carouse_l201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 304,
    minSize: [612, 304],
  },
  [PT.MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 90,
    minSize: [200, 100],
  },
  [PT.MsanV2_MSAN_River_191x100]: {
    placementType: PT.MsanV2_MSAN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
  },
  [PT.MsanV2_MSN_Carousel_169x100]: {
    placementType: PT.MsanV2_MSN_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
  },
  [PT.MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
  },
  [PT.MsanV2_MSN_Restoday_124x100]: {
    placementType: PT.MsanV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
  },
  [PT.MsanV2_MSAN_Rectangle_120x100]: {
    placementType: PT.MsanV2_MSAN_Rectangle_120x100,
    imageType: UAPImageType.Image120x100,
    aspectRatio: 1.2,
    aspectRatioStr: '120:100',
    previewHeight: 250,
    minSize: [300, 250],
  },
  [PT.MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [114, 114],
  },
  [PT.PMax_Video]: {
    placementType: PT.PMax_Video,
    imageType: UAPVideoType.VideoMedia16X9,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },

  //
  // Boost
  [PT.Boost_Hero_Image_Carousel_200x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_200x100,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 320,
    minSize: [200, 100],
  },
  [PT.Boost_Hero_Image_Carousel_122x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_122x100,
    imageType: UAPImageType.Image122x100,
    aspectRatio: 1.225,
    aspectRatioStr: '122:100',
    previewHeight: 320,
    minSize: [450, 368],
  },
  [PT.Boost_Hero_Image_Carousel_159x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_159x100,
    imageType: UAPImageType.Image159x100,
    aspectRatio: 1.59,
    aspectRatioStr: '159:100',
    previewHeight: 320,
    minSize: [585, 368],
  },
  [PT.Boost_Hero_Image_Carousel_180x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_180x100,
    imageType: UAPImageType.Image180x100,
    aspectRatio: 1.805,
    aspectRatioStr: '180:100',
    previewHeight: 320,
    minSize: [664, 368],
  },
  [PT.Boost_Hero_Image_Carousel_233x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_233x100,
    imageType: UAPImageType.Image233x100,
    aspectRatio: 2.33,
    aspectRatioStr: '233:100',
    previewHeight: 250,
    minSize: [703, 301],
  },
  [PT.Boost_Hero_Image_Carousel_320x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_320x100,
    imageType: UAPImageType.Image320x100,
    aspectRatio: 3.20,
    aspectRatioStr: '320:100',
    previewHeight: 180,
    minSize: [703, 219],
  },
  [PT.Boost_Hero_Image_Carousel_57x100]: {
    placementType: PT.Boost_Hero_Image_Carousel_57x100,
    imageType: UAPImageType.Image57x100,
    aspectRatio: 0.57,
    aspectRatioStr: '57:100',
    previewHeight: 320,
    minSize: [210, 368],
  },
  [PT.Boost_Windows_Spotlight_191x100]: {
    placementType: PT.Boost_Windows_Spotlight_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.9,
    aspectRatioStr: '190:100',
    previewHeight: 400,
    minSize: [268, 140],
  },
  [PT.Boost_Discover_Card_1x1]: {
    placementType: PT.Boost_Discover_Card_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 250,
    minSize: [300, 300],
  },
  [PT.Boost_Start_Menu]: {
    placementType: PT.Boost_Start_Menu,
  },
  [PT.Boost_Action_Center]: {
    placementType: PT.Boost_Action_Center,
    logoHeight: 48,
  },
  [PT.Boost_Banner]: {
    placementType: PT.Boost_Banner,
    logoHeight: 20,
  },
  [PT.Boost_Prong1_Prong2_Feed_191x100]: {
    placementType: PT.Boost_Prong1_Prong2_Feed_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.914,
    aspectRatioStr: '191:100',
    previewHeight: 140,
    minSize: [268, 140],
  },
  [PT.Boost_Coachmark_175x100]: {
    placementType: PT.Boost_Coachmark_175x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.75,
    aspectRatioStr: '178:100',
    previewHeight: 160,
    minSize: [280, 160],
  },

  //
  // image extension
  [PT.ImgExt_Audience_Network_WideImage_191x100]: {
    placementType: PT.ImgExt_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.ImgExt_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.ImgExt_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },
  [PT.ImgExt_Bing_Desktop_SingleImage_Extension_178x100]: {
    placementType: PT.ImgExt_Bing_Desktop_SingleImage_Extension_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 45,
    minSize: [624, 350],
    ignoreImageFitting: true,
  },
  [PT.ImgExt_Microsoft_Edge_Medium_Headline_172x100]: {
    placementType: PT.ImgExt_Microsoft_Edge_Medium_Headline_172x100,
    imageType: UAPImageType.Image172x100,
    aspectRatio: 1.72,
    aspectRatioStr: '172:100',
    previewHeight: 174,
    minSize: [300, 174],
  },
  [PT.ImgExt_MSN_Single_Carousel_169x100]: {
    placementType: PT.ImgExt_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 368,
    minSize: [622, 368],
  },
  [PT.ImgExt_MSN_Medium_Headline_155x100]: {
    placementType: PT.ImgExt_MSN_Medium_Headline_155x100,
    imageType: UAPImageType.Image155x100,
    aspectRatio: 1.55,
    aspectRatioStr: '155:100',
    previewHeight: 194,
    minSize: [300, 194],
  },
  [PT.ImgExt_MSN_InArticle_Ad_150x100]: {
    placementType: PT.ImgExt_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.50,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.ImgExt_MSN_Small_Headline_133x100]: {
    placementType: PT.ImgExt_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.ImgExt_Bing_Desktop_MultiImage_Extension_133x100]: {
    placementType: PT.ImgExt_Bing_Desktop_MultiImage_Extension_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 100,
    minSize: [100, 75],
    hasMultiImages: true,
    ignoreImageFitting: true,
  },
  [PT.ImgExt_Bing_Mobile_MultiImage_Extension_133x100]: {
    placementType: PT.ImgExt_Bing_Mobile_MultiImage_Extension_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 310,
    minSize: [100, 75],
    hasMultiImages: true,
    ignoreImageFitting: true,
  },
  [PT.ImgExt_Audience_Network_SquareImage_1x1]: {
    placementType: PT.ImgExt_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },
  [PT.ImgExt_MSN_Double_Carousel_93x100]: {
    placementType: PT.ImgExt_MSN_Double_Carousel_93x100,
    imageType: UAPImageType.Image93x100,
    aspectRatio: 0.93,
    aspectRatioStr: '93:100',
    previewHeight: 333,
    minSize: [311, 333],
    ignoreImageFitting: true,
  },
  [PT.ImgExt_MMAV2_MSN_River_191x100]: {
    placementType: PT.ImgExt_MMAV2_MSN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
    ignoreImageFitting: true,
  },
  [PT.ImgExt_MMAV2_MSN_Single_Carousel_169x100]: {
    placementType: PT.ImgExt_MMAV2_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
    ignoreImageFitting: true,
  },
  [PT.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },

  // text ads
  [PT.Outlook_Text_Mobile]: {
    placementType: PT.Outlook_Text_Mobile,
    logoHeight: 32,
  },
  [PT.Outlook_Text_Web]: {
    placementType: PT.Outlook_Text_Web,
    logoHeight: 28,
  },
  [PT.Bing_Search_Mobile]: {
    placementType: PT.Bing_Search_Mobile,
  },
  [PT.Bing_Search_Desktop]: {
    placementType: PT.Bing_Search_Desktop,
  },
  [PT.Bing_Search_Text]: {
    placementType: PT.Bing_Search_Text,
    logoHeight: 37,
  },

  [PT.Responsive_MMA_WideImage_4x1]: {
    placementType: PT.Responsive_MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    // used to compare ratio values, use string instead of number to avoid precision issue
    aspectRatioStr: '4:1', // refer to: private\ad-creator-tools\packages\media-common-utils\src\aspect-ratio-config.js
    previewHeight: 152,
    minSize: [608, 152],
  },
  [PT.Responsive_MMA_LandscapeImage_191x100]: {
    placementType: PT.Responsive_MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
  },
  [PT.Responsive_MMA_SquareImage_1x1]: {
    placementType: PT.Responsive_MMA_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 400,
    minSize: [470, 470],
  },
  [PT.Responsive_MMA_VerticalImage_1x2]: {
    placementType: PT.Responsive_MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
  },

  // MMA in MSAN
  [PT.Responsive_Audience_Network_WideImage_191x100]: {
    placementType: PT.Responsive_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.Responsive_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.Responsive_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },
  [PT.Responsive_MSN_InArticle_Ad_150x100]: {
    placementType: PT.Responsive_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.Responsive_MSN_Small_Headline_133x100]: {
    placementType: PT.Responsive_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.Responsive_Audience_Network_SquareImage_1x1]: {
    placementType: PT.Responsive_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },

  // Responsive MMA in MSAN V2
  [PT.Responsive_MsanV2_Microsoft_Edge_Carouse_l201x100]: {
    placementType: PT.Responsive_MsanV2_Microsoft_Edge_Carouse_l201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 304,
    minSize: [612, 304],
  },
  [PT.Responsive_MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.Responsive_MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 90,
    minSize: [200, 100],
  },
  [PT.Responsive_MsanV2_MSAN_River_191x100]: {
    placementType: PT.Responsive_MsanV2_MSAN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
  },
  [PT.Responsive_MsanV2_MSN_Carousel_169x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 372,
    minSize: [628, 372],
  },
  [PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
  },
  [PT.Responsive_MsanV2_MSN_Restoday_124x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
  },
  [PT.Responsive_MsanV2_MSAN_Rectangle_120x100]: {
    placementType: PT.Responsive_MsanV2_MSAN_Rectangle_120x100,
    imageType: UAPImageType.Image120x100,
    aspectRatio: 1.2,
    aspectRatioStr: '120:100',
    previewHeight: 250,
    minSize: [300, 250],
  },
  [PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [114, 114],
  },

  [PT.Responsive_PMax_MMA_LandscapeImage_191x100]: {
    placementType: PT.Responsive_PMax_MMA_LandscapeImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 244,
    minSize: [703, 368],
  },
  [PT.Responsive_PMax_MMA_WideImage_4x1]: {
    placementType: PT.Responsive_PMax_MMA_WideImage_4x1,
    imageType: UAPImageType.Image4x1,
    aspectRatio: 4,
    aspectRatioStr: '4:1',
    previewHeight: 152,
    minSize: [608, 152],
  },
  [PT.Responsive_PMax_MMA_VerticalImage_1x2]: {
    placementType: PT.Responsive_PMax_MMA_VerticalImage_1x2,
    imageType: UAPImageType.Image1x2,
    aspectRatio: 0.5,
    aspectRatioStr: '1:2',
    previewHeight: 400,
    minSize: [470, 940],
  },
  [PT.Responsive_PMax_Audience_Network_SquareImage_1x1]: {
    placementType: PT.Responsive_PMax_Audience_Network_SquareImage_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 75,
    minSize: [300, 300],
  },
  [PT.Responsive_PMax_Audience_Network_WideImage_191x100]: {
    placementType: PT.Responsive_PMax_Audience_Network_WideImage_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 200,
    minSize: [703, 368],
  },
  [PT.Responsive_PMax_MSN_InArticle_Ad_150x100]: {
    placementType: PT.Responsive_PMax_MSN_InArticle_Ad_150x100,
    imageType: UAPImageType.Image150x100,
    aspectRatio: 1.5,
    aspectRatioStr: '150:100',
    previewHeight: 200,
    minSize: [300, 200],
  },
  [PT.Responsive_PMax_MSN_Small_Headline_133x100]: {
    placementType: PT.Responsive_PMax_MSN_Small_Headline_133x100,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 75,
    minSize: [100, 75],
  },
  [PT.Responsive_PMax_Microsoft_Edge_Single_Carousel_178x100]: {
    placementType: PT.Responsive_PMax_Microsoft_Edge_Single_Carousel_178x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.78,
    aspectRatioStr: '178:100',
    previewHeight: 350,
    minSize: [624, 350],
  },

  [PT.Responsive_Outlook_Text_Mobile]: {
    placementType: PT.Responsive_Outlook_Text_Mobile,
    logoHeight: 24,
  },
  [PT.Responsive_Outlook_Text_Web]: {
    placementType: PT.Responsive_Outlook_Text_Web,
    logoHeight: 24,
  },
  [PT.Responsive_Bing_Search_Text]: {
    placementType: PT.Responsive_Bing_Search_Text,
  },

  [PT.Responsive_PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100]: {
    placementType: PT.Responsive_PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
    imageType: UAPImageType.Image201x100,
    aspectRatio: 2.01,
    aspectRatioStr: '201:100',
    previewHeight: 200,
    minSize: [612, 304],
  },
  [PT.Responsive_PMax_MMAV2_MSN_Single_Carousel_169x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Single_Carousel_169x100,
    imageType: UAPImageType.Image169x100,
    aspectRatio: 1.69,
    aspectRatioStr: '169:100',
    previewHeight: 200,
    minSize: [628, 372],
  },
  [PT.Responsive_PMax_MMAV2_MSN_Restoday_124x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Restoday_124x100,
    imageType: UAPImageType.Image124x100,
    aspectRatio: 1.24,
    aspectRatioStr: '124:100',
    previewHeight: 84,
    minSize: [104, 84],
  },
  [PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 197,
    minSize: [306, 200],
  },
  [PT.Responsive_PMax_MMAV2_MSN_River_191x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_River_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 157,
    minSize: [300, 157],
  },

  // responsive boost ads
  [PT.Responsive_Boost_Windows_Spotlight_191x100]: {
    placementType: PT.Responsive_Boost_Windows_Spotlight_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.9,
    aspectRatioStr: '190:100',
    previewHeight: 250, // use a smaller value for responsive version
    minSize: [268, 140],
  },
  [PT.Responsive_Boost_Discover_Card_1x1]: {
    placementType: PT.Responsive_Boost_Discover_Card_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 200,
    minSize: [300, 300],
  },
  [PT.Responsive_Boost_Start_Menu]: {
    placementType: PT.Responsive_Boost_Start_Menu,
  },
  [PT.Responsive_Boost_Action_Center]: {
    placementType: PT.Responsive_Boost_Action_Center,
    logoHeight: 48,
  },
  [PT.Responsive_Boost_Banner]: {
    placementType: PT.Responsive_Boost_Banner,
    logoHeight: 20,
  },
  [PT.Responsive_Boost_Prong1_Prong2_Feed_191x100]: {
    placementType: PT.Responsive_Boost_Prong1_Prong2_Feed_191x100,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.914,
    aspectRatioStr: '191:100',
    previewHeight: 140,
    logoHeight: 16,
    imageBorderRadius: 8,
    minSize: [268, 140],
  },
  [PT.Responsive_Boost_Coachmark_175x100]: {
    placementType: PT.Responsive_Boost_Coachmark_175x100,
    imageType: UAPImageType.Image178x100,
    aspectRatio: 1.75,
    aspectRatioStr: '178:100',
    previewHeight: 160,
    minSize: [280, 160],
  },
  [PT.Responsive_Boost_Mini_Spotlight]: {
    placementType: PT.Responsive_Boost_Mini_Spotlight,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.9,
    aspectRatioStr: '190:100',
    previewHeight: 250, // use a smaller value for responsive version
    minSize: [268, 140],
  },
  [PT.Responsive_Boost_Content_Hub]: {
    placementType: PT.Responsive_Boost_Content_Hub,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 100,
    minSize: [133, 100],
  },
  // LinkedIn
  [PT.LinkedIn_Single_Image_Desktop_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Desktop_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 180,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 140,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Medium_Rectangle_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Medium_Rectangle_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 153,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Interstitial_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Interstitial_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 99,
    minSize: [640, 360],
  },
  [PT.LinkedIn_Single_Image_Native_Landscape]: {
    placementType: PT.LinkedIn_Single_Image_Native_Landscape,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 144,
    minSize: [640, 360],
  },

  [PT.LinkedIn_Single_Image_Desktop_Square]: {
    placementType: PT.LinkedIn_Single_Image_Desktop_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 348,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Square]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 275,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Medium_Rectangle_Square]: {
    placementType: PT.LinkedIn_Single_Image_Medium_Rectangle_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 275,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Mobile_Interstitial_Square]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Interstitial_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 188,
    minSize: [360, 360],
  },
  [PT.LinkedIn_Single_Image_Native_Square]: {
    placementType: PT.LinkedIn_Single_Image_Native_Square,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 275,
    minSize: [360, 360],
  },

  [PT.LinkedIn_Single_Image_Mobile_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Vertical,
    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 275,
    minSize: [360, 640],
  },
  [PT.LinkedIn_Single_Image_Medium_Rectangle_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Medium_Rectangle_Vertical,
    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  [PT.LinkedIn_Single_Image_Mobile_Interstitial_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Mobile_Interstitial_Vertical,
    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 150,
    minSize: [360, 640],
  },
  [PT.LinkedIn_Single_Image_Native_Vertical]: {
    placementType: PT.LinkedIn_Single_Image_Native_Vertical,
    imageType: UAPImageType.Image4x5,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  [PT.Unified_App_Ads_Video_Horizontal]: {
    placementType: PT.Unified_App_Ads_Video_Horizontal,
    imageType: UAPVideoType.VideoMedia16X9,
    aspectRatio: 0.8,
    aspectRatioStr: '4:5',
    previewHeight: 220,
    minSize: [360, 640],
  },
  [PT.Unified_App_Ads_Bing_Search]: {
    placementType: PT.Unified_App_Ads_Bing_Search,
    imageType: UAPImageType.Image133x100,
    aspectRatio: 1.33,
    aspectRatioStr: '133:100',
    previewHeight: 100,
    minSize: [100, 75],
  },
  [PT.Unified_App_Ads_Bing_Search_Text]: {
    placementType: PT.Unified_App_Ads_Bing_Search_Text,
  },
  [PT.Unified_App_Ads_Causal_Games_Dimensions]: {
    placementType: PT.Unified_App_Ads_Causal_Games_Dimensions,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 250,
    minSize: [300, 300],
  },
  [PT.Unified_App_Ads_M365_Outlook]: {
    placementType: PT.Unified_App_Ads_M365_Outlook,
  },
  [PT.Unified_App_Ads_MSN_Display]: {
    placementType: PT.Unified_App_Ads_MSN_Display,
    imageType: UAPImageType.Image191x100,
    aspectRatio: 1.91,
    aspectRatioStr: '191:100',
    previewHeight: 180,
    minSize: [640, 360],
  },
  // TODO: add configs for vertical and square images
};

export const UAPLPlacementMetaListV2 /* : Record<PT, UAPPlacementMeta> */ = {
  ...UAPLPlacementMetaList,
  [PT.MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },
  [PT.MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
  },
  [PT.MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 100,
    minSize: [200, 100],
  },
  [PT.PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
  },
  [PT.PMax_MMAV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },
  [PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },
  [PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_MsanV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
  },
  [PT.Responsive_MsanV2_MSAN_Banner_2x1]: {
    placementType: PT.Responsive_MsanV2_MSAN_Banner_2x1,
    imageType: UAPImageType.Image200x100,
    aspectRatio: 2,
    aspectRatioStr: '2:1',
    previewHeight: 100,
    minSize: [200, 100],
  },
  [PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100]: {
    placementType: PT.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100,
    imageType: UAPImageType.Image153x100,
    aspectRatio: 1.53,
    aspectRatioStr: '153:100',
    previewHeight: 200,
    minSize: [306, 200],
  },
  [PT.Responsive_PMax_MMAV2_Microsoft_Edge_Mobile_1x1]: {
    placementType: PT.Responsive_PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
    imageType: UAPImageType.Image1x1,
    aspectRatio: 1,
    aspectRatioStr: '1:1',
    previewHeight: 114,
    minSize: [114, 114],
  },
};

export const getPlacementListMetaData = (placementTypes, isAdPreviewRefreshEnabled) => {
  const PlacementMetaList = isAdPreviewRefreshEnabled ? UAPLPlacementMetaListV2 : UAPLPlacementMetaList;
  const types = _.compact(placementTypes);

  if (_.isEmpty(types)) {
    return [];
  }
  const ret = _.map(
    types,
    placementType => PlacementMetaList[placementType]
  );
  return ret;
};

export const getPlacementListMetaDataByImageType = (imageTypes) => {
  const types = _.compact(imageTypes);
  if (_.isEmpty(types)) {
    return [];
  }
  const placementMetaList = Object.values(UAPLPlacementMetaList);
  const ret = _.chain(types)
    .map(imgType => _.filter(placementMetaList, ({ imageType }) => imgType && imageType && (imageType.toLowerCase() === imgType.toLowerCase())))
    .flatten()
    .compact()
    .uniq()
    .value();
  return ret;
};
